import React, { FormEvent } from 'react';
import FilterPillAttributes from '../filter-pill-attributes';
import { IFilterContext, useDfContext } from '../../context/df-context';
import { useSearch } from '../../hooks/use-search';

export default function ProductFilters(): React.ReactElement {
  const { dispatchResult } = useDfContext<IFilterContext>();

  const applySubmitAction = useSearch();

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    dispatchResult();
  };

  return (
    <form method="GET" action={applySubmitAction} onSubmit={handleSubmit}>
      <div className="df-product-downloads__filters">
        <FilterPillAttributes isProductPage />
      </div>
    </form>
  );
}
